import { render, staticRenderFns } from "./PaymentAggregations.vue?vue&type=template&id=764198f4&scoped=true&"
import script from "./PaymentAggregations.vue?vue&type=script&lang=js&"
export * from "./PaymentAggregations.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAggregations.vue?vue&type=style&index=0&id=764198f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764198f4",
  null
  
)

export default component.exports